export default "/images/default_preview.png?e399cc99a04e652e5017f73a13080bbd";